// models
import {
  BacktestTranscriptChoice,
  EvaluationSourceOrigin,
  SourceTranscript,
} from '@karehero/models';
import { formatDateTime } from '@karehero/helpers/datetime';

const SHORT_SHA_LENGTH = 7;

export const TRANSCRIPT_CHOICE_LABEL: Record<BacktestTranscriptChoice, string> =
  {
    chosen: 'Chosen transcript',
    fresh: 'Fresh each run',
  };

export const ORIGIN_LABEL: Record<EvaluationSourceOrigin, string> = {
  aircall: 'Aircall',
  upload: 'Upload',
};

export const EMPTY_VALUE = '—';

export const shortSha = (sha?: string | null) =>
  sha ? sha.slice(0, SHORT_SHA_LENGTH) : EMPTY_VALUE;

export const transcriptLabel = (transcript: SourceTranscript) =>
  [
    transcript.transcribedAt && formatDateTime(transcript.transcribedAt),
    transcript.model,
    shortSha(transcript.codeVersion),
  ]
    .filter(Boolean)
    .join(' · ');
